module.exports = __webpack_public_path__ + "static/media/CaixaLivre3.652e2d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCaixaLivre/CaixaLivre3.png
// module id = 2045
// module chunks = 0